import React from 'react';

const MainMenu = ({ setCurrentView, fetchMyRequests, handleSupportClick }) => (
    <div id="main-menu">
        <button onClick={() => setCurrentView('buySellUSDT')}>Купить/Продать USDT</button>
        <button onClick={() => setCurrentView('alipayWechat')}>Пополнить Alipay/Wechat</button>
        <button onClick={() => setCurrentView('reschedule')}>Заказать перестановку</button>
        <div className="block-buttons">
            <button onClick={fetchMyRequests}  style={{width:'140px'}} className="rows">Мои заявки</button>
            <button onClick={handleSupportClick} style={{margin:'0 0 0 10px', width:'140px'}} className="rows">Поддержка</button>
        </div>
        <button onClick={() => setCurrentView('aboutUs')} className="rows">О нас</button>
        <button onClick={() => setCurrentView('referralProgram')} className="rows">Реферальная программа</button>
    </div>
);

export default MainMenu;